export default class SafetyNumber {
  constructor(data) {
    const defaults = {
      dummy: null,
    };
    data = {
      ...defaults,
      ...data,
    };
    this.fafIndicator = data.fafIndicator;
    this.fafNumber = data.fafNumber;
    this.owner = data.owner;
  }
}
